export default __webpack_public_path__ + "achievement.e7a3deb820f0607f.svg";